<template>
  <a-select
    allowClear
    show-search
    style="width: 100%"
    :mode="mode"
    :disabled="disabled"
    :filter-option="filterOption"
    v-model="selectedWarehouse"
    :placeholder="selfPlaceholder"
    :not-found-content="loading ? undefined : null"
    @change="selectWarehouse"
    @focus="fetchWarehouseList"
  >
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <a-select-option v-for="item in warehouseList" :value="item.uniqueCode" :key="item.uniqueCode">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
import http from '../service/axios'
import api from '../service/api'

export default {
  model: {
    prop: 'code',
    event: 'change',
  },
  props: ['placeholder', 'disabled', 'code', 'mode'],
  data() {
    return {
      warehouseList: [],
      loading: false,
      selectedWarehouse: undefined,
    }
  },
  computed: {
    selfPlaceholder() {
      return this.placeholder || this.$t('请选择仓库')
    },
  },
  watch: {
    code: {
      immediate: true,
      handler(val) {
        if (!val && val !== 0) {
          this.selectedWarehouse = undefined
        }
        this.fetchWarehouseList()
        this.setDefault()
      },
    },
  },
  methods: {
    clear() {
      this.selectedWarehouse = undefined
    },
    async fetchWarehouseList() {
      if (this.warehouseList.length) return
      this.loading = true
      let res = await http({
        url: api.getWarehouseListNew,
        type: 'post',
        data: {
          merchantCode: this.$store.state.userSession.merchantCode,
          status: true,
        },
      })
      this.loading = false
      this.warehouseList = res.result?.list || []
      this.setDefault()
    },
    setDefault() {
      if (this.code || this.code === 0) {
        if (this.mode === 'multiple') {
          this.selectWarehouse(this.code)
        } else {
          let data =
            this.warehouseList.find(
              (item) => item.uniqueCode === this.code || item.code === this.code
            ) || {}
          this.selectedWarehouse = data.uniqueCode || this.code
          this.$emit('selected', data)
        }
      } else {
        this.selectedWarehouse = undefined
      }
    },
    selectWarehouse(val) {
      this.selectedWarehouse = val
      if (this.mode === 'multiple') {
        const selectedCodes = Array.isArray(val) ? val : []
        const warehouseList = selectedCodes.map((code) => {
          const item =
            this.warehouseList.find((w) => w.uniqueCode === code || w.code === code) || {}
          return {
            warehouseCode: item.code,
            warehouseName: item.name,
            wmsApp: item.wmsAppCode,
            uniqueCode: item.uniqueCode,
          }
        })
        this.$emit('selected', { warehouseList })
        this.$emit('update:code', selectedCodes)
        this.$emit('change', selectedCodes, { warehouseList })
        this.$emit('input', selectedCodes)
      } else {
        let data =
          this.warehouseList.find((item) => item.uniqueCode === val || item.code === val) || {}
        const finalVal = data.uniqueCode || val
        this.selectedWarehouse = finalVal
        this.$emit('selected', data)
        this.$emit('update:code', finalVal)
        this.$emit('change', finalVal, data)
        this.$emit('input', finalVal)
      }
    },
    filterOption(input, option) {
      const text = option?.componentOptions?.children?.[0]?.text || ''
      return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
}
</script>
